import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { API, haptic } from "../../constants";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);
  const entrar = async () => {
    setCarregando(true); setErro("");
    try {
      const res = await axios.post(`${API}/login`, { email, senha });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("nome", res.data.nome);
      localStorage.setItem("usuario_id", res.data.id);
      localStorage.setItem("perfil", res.data.perfil);
      localStorage.setItem("pode_criar_tarefas", res.data.pode_criar_tarefas !== false ? "true" : "false");
      haptic([10, 50, 10]);
      onLogin(res.data);
    } catch { setErro("Email ou senha incorretos. Tente novamente."); }
    setCarregando(false);
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-950 via-green-900 to-green-800 dark:from-gray-950 dark:via-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0, y: 32 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: "easeOut" }} className="w-full max-w-sm">
        <div className="text-center mb-8">
          <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.1, duration: 0.4 }}
            className="inline-flex items-center justify-center w-16 h-16 bg-green-500 rounded-2xl mb-4 shadow-lg">
            <span className="text-3xl">🌱</span>
          </motion.div>
          <h1 className="text-2xl font-bold text-white">AgroFlow AI</h1>
          <p className="text-green-300 text-sm mt-1">Gestão inteligente de fazendas</p>
        </div>
        <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 shadow-2xl">
          <h2 className="text-base font-semibold text-gray-800 dark:text-white mb-5">Entrar na plataforma</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-green-500 transition" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5">Senha</label>
              <input type="password" value={senha} onChange={e => setSenha(e.target.value)} placeholder="••••••••"
                onKeyDown={e => e.key === "Enter" && entrar()}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-green-500 transition" />
            </div>
            {erro && <p className="text-xs text-red-600 font-medium text-center">{erro}</p>}
            <button onClick={entrar} disabled={carregando}
              className="w-full bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white font-semibold py-3 rounded-xl text-sm transition-all shadow-md min-h-11">
              {carregando ? <span className="flex items-center justify-center gap-2"><svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>Entrando...</span> : "Entrar"}
            </button>
          </div>
        </div>
        <p className="text-center text-green-400 text-xs mt-6">© 2026 AgroFlow AI</p>
      </motion.div>
    </div>
  );
}
